<template>
  <div class="flex items-center gap-2">
    <div class="relative h-1 w-20 overflow-hidden rounded-full bg-gray-100">
      <div
        class="absolute inset-y-0 left-0 rounded-full transition-all"
        :class="fillClass"
        :style="{ width: pct + '%' }"
      />
    </div>
    <span class="text-xs min-w-[42px]" :class="numClass">
      {{ displayScore }}
    </span>
  </div>
</template>

<script>
import { normalizeScore } from "./utils";

export default {
  name: "ScoreBar",
  props: {
    score: { type: Number, default: 0 },
    result: { type: String, default: "success" },
  },
  computed: {
    normalized() {
      return normalizeScore(this.score) ?? 0;
    },
    pct() {
      return Math.max(0, Math.min(100, Math.round(this.normalized * 100)));
    },
    displayScore() {
      return this.normalized.toFixed(3);
    },
    isSuccess() {
      return this.result === "success";
    },
    fillClass() {
      if (!this.isSuccess) return "bg-red-500";
      if (this.normalized > 0.85) return "bg-green-500";
      return "bg-orange-500";
    },
    numClass() {
      if (!this.isSuccess) return "text-red-600";
      if (this.normalized > 0.85) return "text-green-600";
      return "text-muted-foreground";
    },
  },
};
</script>
